<template>
  <div class="app-layout-event" :class="classList" :style="styleColor">
    <div class="app-layout-event__inner">

      <div class="app-layout-event__title" v-if="data.title">{{ data.title }}</div>

      <div class="app-layout-event__info-wrapper">
        <div class="app-layout-event__info">
          <div class="app-layout-event__date" v-if="data.dateNumber">
            <span>{{ data.dateNumber }}</span>
            <span class="app-layout-event__date-label"
                  v-if="data.dateLabel">{{ data.dateLabel }}</span>
          </div>
          <div class="app-layout-event__time">
            <span v-if="data.time_start">{{ data.time_start }}</span><span>  - </span>
            <span v-if="data.time_end">{{ data.time_end }}</span>
            <span class="app-layout-event__time-label"
                  v-if="data.timeLabel">{{ data.timeLabel }}</span></div>
          <div class="app-layout-event__track"
               v-if="data.trek && !hideTracks || treksList && !hideTracks">
            <div class="app-layout-event__track-label"
                 v-if="data.trekLabel">{{ data.trekLabel }}</div>
            <div class="app-layout-event__track-text" v-if="treksList">
              <span class="app-layout-event__track-item"
                 v-for="(item, idx) in treksList" :key="`item${idx}`">
                {{item.name}}
              </span>
            </div>
            <div class="app-layout-event__track-text" v-else
                 :style="data.trek_color ? `--color: ${data.trek_color}`:''">
              {{ data.trek }}
            </div>
          </div>
          <div class="app-layout-event__location"
               :class="[hideTracks || !data.trek ? 'no-tracks' : '']"
               v-if="data.hallNumber">
            <span>{{ data.hallNumber }}</span>
            <span class="app-layout-event__location-label">{{ data.hallLabel }}</span>
          </div>
          <div class="app-layout-event__extra" v-if="data.extra">{{ data.extra }}</div>
        </div>
        <div class="app-layout-event__info-pattern"></div>
      </div>

      <div class="app-layout-event__partners app-layout-event__partners--grid"
           v-if="data.general_partners.length > 0 || data.intellectual_partners.length > 0"
      >
        <div class="app-layout-event__row" v-if="data.general_partners.length > 0">
          <div class="app-layout-event__partners-title" v-if="data.generalPartnersTitle">
            <span>{{ data.generalPartnersTitle }}</span>
          </div>
          <div class="app-layout-event__partners-items">
            <div class="app-layout-event__slider">
              <div ref="swiperGeneral" class="swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"
                       v-for="(item, idx) in data.general_partners" :key="`partner${idx}`"
                  >
                    <AppCardPartner :data="item"/>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination" :class="`swiper-pagination${data.id}-1`"></div>
            </div>
          </div>
        </div>
        <div class="app-layout-event__row" v-if="data.intellectual_partners.length > 0">
          <div class="app-layout-event__partners-title" v-if="data.intellectualPartnersTitle">
            <span>{{ data.intellectualPartnersTitle }}</span>
          </div>
          <div class="app-layout-event__partners-items">
            <div class="app-layout-event__slider">
              <div ref="swiperIntellectual" class="swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"
                       v-for="(item, idx) in data.intellectual_partners" :key="`partner${idx}`"
                  >
                    <AppCardPartner :data="item"/>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination" :class="`swiper-pagination${data.id}-2`"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="app-layout-event__partners" v-else-if="data.partners.length > 0">
        <div class="app-layout-event__partners-title" v-if="data.partnersTitle">
          <span>{{ data.partnersTitle }}</span>
        </div>
        <div class="app-layout-event__partners-items">
          <div class="app-layout-event__partner" v-for="(item, idx) in data.partners"
               :key="`partner${idx}`"><AppCardPartner :data="item"/></div>
        </div>
      </div>

      <div class="app-layout-event__description user-text" v-if="data.description"
           v-html="data.description"></div>
      <div class="app-layout-event__important user-text"
           v-if="data.important" v-html="data.important"></div>
      <div class="app-layout-event__description-extra user-text" v-if="data.descriptionExtra"
           v-html="data.descriptionExtra"></div>

      <div class="app-layout-event__rollback" @click="$emit('event-close')">
        <div class="app-layout-event__rollback-item">
          <span class="app-layout-event__rollback-icon"></span>
          <span class="app-layout-event__rollback-text"
                v-if="data.rollbackText">{{ data.rollbackText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import AppCardPartner from '@/components/app-card-partner/app-card-partner.vue';

export default {
  name: 'AppLayoutEvent',
  props: ['data', 'newVersion'],
  data() {
    return {
      hideTracks: false, // true - если нужно локально скрыть треки
      activeIndex: 0,
      sliderGeneral: null,
      sliderIntellectual: null,
    };
  },
  computed: {
    classList() {
      if (this.newVersion) return 'layout-new';
      if (this.treksList && this.treksList.length > 1) return 'has-tracks-list';
      return null;
    },
    treksList() {
      if (this.data?.treks) {
        return Array.from(Object.values(this.data.treks)).filter((item) => item !== null);
      }
      return null;
    },
    styleColor() {
      let treksLength = 0;

      // если треки из справочника
      if (this.data?.treks) {
        // eslint-disable-next-line max-len
        const treksList = Array.from(Object.values(this.data.treks)).filter((item) => item !== null);
        treksLength = treksList.length > 0 ? treksList.length : 0;
        // если передан один трек, то присваивается цвет, если несколько - цвет на стилях
        if (treksLength === 1) {
          return `--main-color: ${treksList[0].trek_color}`;
        }
        return `--main-color: ${this.data.trek_color}`;
      }
      // если трек один
      const trekColor = this.data?.trek_color;
      if (trekColor && treksLength < 2) {
        return `--main-color: ${this.data.trek_color}`;
      }
      return null;
    },
  },
  components: {
    AppCardPartner,
  },
  methods: {
    sliderUpdate() {
      if (this.sliderGeneral) this.sliderGeneral.update();
      if (this.sliderIntellectual) this.sliderIntellectual.update();
    },
  },
  mounted() {
    if (this.data.general_partners.length > 0) {
      const SECOND = 1000; // milliseconds
      this.sliderGeneral = new Swiper(this.$refs.swiperGeneral, {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        autoplay: {
          delay: 3 * SECOND,
          disableOnInteraction: false,
        },
        speed: SECOND,
        pagination: {
          el: `.swiper-pagination${this.data.id}-1`,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        on: {
          slideChange: (swiper) => {
            this.activeIndex = swiper.realIndex;
          },
        },
      });
      this.sliderGeneral.update();
    }

    if (this.data.intellectual_partners.length > 0) {
      const SECOND = 1000; // milliseconds
      this.sliderIntellectual = new Swiper(this.$refs.swiperIntellectual, {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        autoplay: {
          delay: 3 * SECOND,
          disableOnInteraction: false,
        },
        speed: SECOND,
        pagination: {
          el: `.swiper-pagination${this.data.id}-2`,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        on: {
          slideChange: (swiper) => {
            this.activeIndex = swiper.realIndex;
          },
        },
      });

      this.sliderIntellectual.update();
    }
  },
};

</script>

<style lang="scss">
  @import "app-layout-event";
</style>
